export default 'M5.44 1.94a1.5 1.5 0 0 0 0 2.12L9.38 8l-3.94 3.94a1.5 1.5 0 0 0 2.12 2.12l5-5a1.5 1.5 0 0 0 0-2.12l-5-5a1.5 1.5 0 0 0-2.12 0';